import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import { isPhase1DestinationEnabled } from "../config/appScope";

const cardData = [
  {
    title: "Animal List",
    path: "/animals",
    description: "View and manage all animals",
  },
  {
    title: "Milk Records",
    path: "/milking",
    description: "View and Manage milk production records",
  },
  {
    title: "Treatments",
    path: "/treatments",
    description: "Manage animal medical treatments",
  },
  {
    title: "Medicine Stock Dashboard",
    path: "/medicines",
    description: "Track stock levels, usage trends, and lot inventory",
  },
  {
    title: "Income",
    path: "/income",
    description: "Track farm income sources",
  },
  {
    title: "Expenses",
    path: "/expenses",
    description: "Manage operational expenses",
  },
  {
    title: "Animal Stock Taking",
    path: "/stock-taking",
    description: "Take animal stock",
  },
  {
    title: "Farm Planner",
    path: "planning/activities",
    description: "Plan effectively",
  },
  {
    title: "Activity Calendar",
    path: "/planning/calendar",
    description: "View and manage activities in calendar view",
  },
  {
    title: "Calves",
    path: "/calves",
    description: "View and manage calf records",
  },
  { title: "Reports", path: "/reports", description: "Generate farm reports" },
  { title: "System Admin", path: "/", description: "Platform dashboard" },
];

const Home = () => {
  const visibleCards = cardData.filter((card) =>
    isPhase1DestinationEnabled(card.path)
  );

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Farm Management Dashboard
      </Typography>
      <Grid container spacing={4}>
        {visibleCards.map((card) => (
          <Grid item xs={12} sm={6} md={4} key={card.title}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  {card.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {card.description}
                </Typography>
              </CardContent>
              <Box sx={{ p: 2 }}>
                <Button
                  component={Link}
                  to={card.path}
                  variant="contained"
                  fullWidth
                >
                  Open
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Home;
